import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsDateString, IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class GenerarComisionSupervisorDto {
  @ApiProperty({ example: '2026-05-01' })
  @IsNotEmpty()
  @IsDateString()
  periodo_desde: string;

  @ApiProperty({ example: '2026-05-31' })
  @IsNotEmpty()
  @IsDateString()
  periodo_hasta: string;

  @ApiPropertyOptional()
  @IsOptional()
  @IsString()
  observaciones?: string;
}
